import { BREAKPOINTS, BreakpointSize } from '@shared/consts/breakpoints';
import { useBreakpoints } from '@vueuse/core';
import { computed } from 'vue';

export function useViewport(type: 'greater' | 'smaller', size: BreakpointSize) {
    if (type === 'greater') {
        const ADJUSTED_BREAKPOINTS = adjustBreakpoints();
        return useBreakpoints(ADJUSTED_BREAKPOINTS).greater(size);
    }

    return useBreakpoints(BREAKPOINTS).smaller(size);
}

function adjustBreakpoints() {
    return Object.keys(BREAKPOINTS).reduce(
        (adjusted, key) => {
            const breakpointKey = key as keyof typeof BREAKPOINTS;
            const value = BREAKPOINTS[breakpointKey];
            adjusted[breakpointKey] = value > 0 ? value - 1 : value;
            return adjusted;
        },
        {} as Record<keyof typeof BREAKPOINTS, number>
    );
}

export function useScreenSize() {
    const isTablet = computed<boolean>(() => useViewport('greater', 'sm').value);
    const isDesktop = computed<boolean>(() => useViewport('greater', 'md').value);
    const isLargeDesktop = computed<boolean>(() => useViewport('greater', 'lg').value);

    return { isTablet, isDesktop, isLargeDesktop };
}
